import React from 'react'
import { connect } from 'react-redux'
import { selectPage, selectPageMeta } from '../../store/pages'

import NotFound from '../../components/container/NotFound'
import Head from '../../components/utils/Head'
import SliceProcessor from '../../components/utils/SliceProcessor'
import Theme from '../../components/utils/Theme'

const Page = ({
  page = {},
  meta = { title: 'Not Found' }
}) => (
  <Theme>
    <div>
      <Head {...meta} />
      {page.content
        ? <SliceProcessor slices={page.content} />
        : <NotFound />}
    </div>
  </Theme>
)

const mapState = (store, props) => ({
  page: selectPage(store, props),
  meta: selectPageMeta(store, props)
})

export default connect(mapState)(Page)



// WEBPACK FOOTER //
// ./routes/Page/index.js